import { __assign, __makeTemplateObject, __read, __spreadArray } from "tslib";
import { isEmpty } from 'lodash-es';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import { ItemUtils, selectors } from '@marvelapp/design-creator';
import styled from '@marvelapp/styled';
import { colors } from '@marvelapp/theme';
import { Box, Grid } from '@marvelapp/ui';
import SidebarFilterEmptyState from '../SidebarFilterEmptyState';
import LayerListItem from './LayerListItem';
import { LayerListContext } from './context';
import { useLayerFilter } from './hooks';
import { useLayersDrag } from './hooks/useLayersDrag';
import { getExpandedAncestors } from './utils';
/** @param {any} */
function LayerList(_a) {
    var design = _a.design, _b = _a.selectedIds, selectedIds = _b === void 0 ? [] : _b, onLayerMouseEnter = _a.onLayerMouseEnter, onLayerMouseLeave = _a.onLayerMouseLeave, onLayerMouseDown = _a.onLayerMouseDown, onLayerMouseUp = _a.onLayerMouseUp, onRename = _a.onRename, onDragToTarget = _a.onDragToTarget, filterText = _a.filterText;
    var rootIds = ItemUtils.getChildIds(selectors.getRoot(design)) || [];
    var itemsMap = design.items || {};
    var _c = __read(useState({}), 2), expandedMap = _c[0], setExpandedMap = _c[1];
    var filter = useLayerFilter(design, filterText);
    var rootItems = __spreadArray([], __read(rootIds), false).reverse();
    var _d = useLayersDrag(onDragToTarget), dropzoneCursorRef = _d.dropzoneCursorRef, listContainerRef = _d.listContainerRef, onLayerDragMouseDown = _d.onMouseDown;
    useEffect(function () {
        return autorun(function () {
            if (selectedIds) {
                var updatedExpandedMap_1 = getExpandedAncestors(design, selectedIds);
                setExpandedMap(function (prevState) {
                    return __assign(__assign({}, prevState), updatedExpandedMap_1);
                });
            }
        });
    }, [design, selectedIds]);
    var onMouseDownItem = useCallback(function (itemId, event) {
        if (onLayerMouseDown) {
            onLayerMouseDown(itemId, event);
        }
        onLayerDragMouseDown(itemId, event);
    }, [onLayerDragMouseDown, onLayerMouseDown]);
    var onMouseUpItem = useCallback(function (itemId, event) {
        if (onLayerMouseUp) {
            onLayerMouseUp(itemId, event);
        }
    }, [onLayerMouseUp]);
    var onMouseEnterItem = useCallback(function (itemId) {
        if (onLayerMouseEnter) {
            onLayerMouseEnter(itemId);
        }
    }, [onLayerMouseEnter]);
    var onMouseLeaveItem = useCallback(function (itemId) {
        if (onLayerMouseLeave) {
            onLayerMouseLeave(itemId);
        }
    }, [onLayerMouseLeave]);
    var setIsExpandedLayer = useCallback(function (layerId, isExpanded) {
        setExpandedMap(function (prevState) {
            var _a;
            return __assign(__assign({}, prevState), (_a = {}, _a[layerId] = isExpanded, _a));
        });
    }, [setExpandedMap]);
    var contextValue = {
        selectedIds: selectedIds,
        expandedMap: expandedMap,
        itemsMap: itemsMap,
        filter: filter,
        setIsExpandedLayer: setIsExpandedLayer,
    };
    var showFilterEmptyState = filter.filterText && isEmpty(filter.filteredItems);
    return (React.createElement(LayerListContext.Provider, { value: contextValue },
        React.createElement(Box, { "data-testid": "layer-list", flex: 1, overflowY: "scroll", padding: 2, ref: listContainerRef },
            React.createElement(Grid, { gridRowGap: 1, gridTemplateColumns: "100%", position: "relative" },
                React.createElement(DropzoneCursor, { ref: dropzoneCursorRef }),
                rootItems.map(function (id) {
                    return itemsMap[id] ? (React.createElement(LayerListItem, { item: itemsMap[id], key: id, onMouseDown: onMouseDownItem, onMouseEnter: onMouseEnterItem, onMouseLeave: onMouseLeaveItem, onMouseUp: onMouseUpItem, onRename: onRename })) : null;
                })),
            showFilterEmptyState && (React.createElement(SidebarFilterEmptyState, { filterText: filterText, type: "layer" })))));
}
var DropzoneCursor = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  right: 0;\n  background: ", ";\n  position: absolute;\n"], ["\n  right: 0;\n  background: ", ";\n  position: absolute;\n"])), colors.marvel);
export default observer(LayerList);
var templateObject_1;
